import { Provider } from '@supabase/supabase-js';

import { supabaseClient } from '@/utils/supabase-client';

export const authApi = {
  /**
   * Sign in with email and password
   */
  signInWithPassword: async (email: string, password: string) => {
    return supabaseClient.auth.signInWithPassword({
      email,
      password,
    });
  },

  /**
   * Sign up with email and password
   */
  signUp: async (
    email: string,
    password: string,
    phone: string,
    name: string,
  ) => {
    return supabaseClient.auth.signUp({
      email,
      password,
      phone,
      options: { data: { name } },
    });
  },

  /**
   * Sign out current user
   */
  signOut: async () => {
    return supabaseClient.auth.signOut();
  },

  /**
   * Reset password via email
   * TODO: Look at how this redirect integreates with router
   */
  resetPassword: async (email: string) => {
    return supabaseClient.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/forgot-password`,
    });
  },

  /**
   * Update user password
   */
  updatePassword: async (password: string) => {
    return supabaseClient.auth.updateUser({
      password,
    });
  },

  /**
   * Sign in with OAuth provider
   */
  signInWithOAuth: async (provider: Provider) => {
    return supabaseClient.auth.signInWithOAuth({
      provider,
      options: {
        redirectTo: window.location.origin,
      },
    });
  },

  /**
   * Get current session
   */
  getSession: async () => {
    return supabaseClient.auth.getSession();
  },

  /**
   * Refresh session
   */
  refreshSession: async () => {
    return supabaseClient.auth.refreshSession();
  },

  /**
   * Get current user
   */
  getUser: (userId: string) => {
    return supabaseClient.from('user').select('*').eq('id', userId).single();
  },
} as const;
